import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BookingRow, type BookingSummary } from '../components/BookingRow';
import { customerApi } from '../customer_api';

export function Bookings() {
  const [bookings, setBookings] = useState<BookingSummary[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    customerApi<{ bookings: BookingSummary[] }>('/api/customer/bookings')
      .then((data) => setBookings(data.bookings))
      .catch(() => setError('Could not load bookings. Please try again.'));
  }, []);

  return (
    <main className="min-h-[100dvh] bg-background px-4 py-6 sm:px-6 sm:py-10">
      <div className="mx-auto max-w-2xl">
        <span
          style={{
            fontSize: '0.7rem',
            textTransform: 'uppercase',
            letterSpacing: '0.18em',
            color: 'var(--muted-foreground, oklch(0.52 0.008 75))',
          }}
        >
          Your bookings
        </span>
        <h1
          style={{
            fontSize: '2.25rem',
            fontWeight: 500,
            letterSpacing: '-0.02em',
            margin: '0.4rem 0 1.5rem',
          }}
        >
          Bookings
        </h1>
        <p style={{ margin: '-0.75rem 0 1.5rem', fontSize: '0.9rem' }}>
          <Link to="/account/recurring-visits" style={{ color: 'var(--primary, #004AAD)' }}>
            Manage recurring visits
          </Link>
        </p>

        {error && <p style={{ color: 'var(--destructive, oklch(0.55 0.15 30))' }}>{error}</p>}

        {!error && bookings === null && (
          <p style={{ color: 'var(--muted-foreground, oklch(0.52 0.008 75))' }}>Loading…</p>
        )}

        {bookings !== null && bookings.length === 0 && (
          <div
            style={{
              marginTop: '2rem',
              padding: '2.5rem 1.5rem',
              borderRadius: '14px',
              border: '1px solid var(--border, oklch(0.915 0.005 80))',
              textAlign: 'center',
            }}
          >
            <p
              style={{
                margin: 0,
                color: 'var(--muted-foreground, oklch(0.52 0.008 75))',
                fontSize: '0.95rem',
              }}
            >
              No bookings yet.
            </p>
          </div>
        )}

        {bookings !== null && bookings.length > 0 && (
          <div
            style={{
              borderTop: '1px solid var(--border, oklch(0.915 0.005 80))',
            }}
          >
            {bookings.map((b) => (
              <div
                key={b.id}
                style={{ borderBottom: '1px solid var(--border, oklch(0.915 0.005 80))' }}
              >
                <BookingRow booking={b} />
              </div>
            ))}
          </div>
        )}
      </div>
    </main>
  );
}
